<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1 #title>未精算整理照会画面</h1>

<div *ngIf="businessDate">
  <form [formGroup]="sgke012arequestData" (ngSubmit)="search()">
    <!-- 検索条件コンポーネント -->
    <app-sgke010d-search-condition *ngIf="initialhyojiInfo" [initialhyojiInfo] = "initialhyojiInfo" [businessDate]="businessDate" (onClickClearEvent)="clear()">
    </app-sgke010d-search-condition>
  </form>
</div>

<!-- 検索結果コンポーネント -->
<app-sgke010d-search-result *ngIf="searchService.searched" [responseList]="searchResultList"
  (onDblClickFlgEmitter)="dblClickFlgSet()">
</app-sgke010d-search-result>